import { OnInit, Component } from "@angular/core";
import { DatePipe } from "@angular/common";

import { HttpErrorResponse } from "@angular/common/http";
import { NzNotificationService } from "ng-zorro-antd";

import {
  GlobalComponent,
  Result,
  Aziende,
  Dipendente,
} from "../../environments/global";

@Component({
  selector: "app-dipendenti-report",
  templateUrl: "dipendenti.report.html",
  styleUrls: ["dipendenti.report.scss"],
  providers: [DatePipe],
})
export class DipendentiReportComponent implements OnInit {
  // TABLE VARS
  timesData = [];
  public displayData = [...this.timesData];
  usersData = [];
  ordersData = [];
  editCache = {};
  sortName = null;
  sortValue = null;
  // COMPONNET VARS
  companyData: Array<string> = Aziende;
  isSpinning: boolean = false;
  isLoading: boolean = false;
  selectedCompany: string;
  selectedUsers = [];
  selectedUser: Dipendente;
  currentTotale: string;
  rangeDate: Date[];
  rangePlace: string[] = ["Da data", "A Data"];
  dateFormat = "dd/MM/yyyy";

  // ################################################
  // CLASS: CONSTRUCTOR
  constructor(
    public g: GlobalComponent,
    private datepipe: DatePipe,
    private notification: NzNotificationService
  ) {
    this.setup();
  }
  // ################################################
  // CLASS: ON INIT
  ngOnInit() {
    this.setup();
    this.loadData();
  }
  setup() {
    // SETUP INTERFACE
    this.g.menuState = 8;
    this.g.homeTitle = "Report Dipendenti";
  }
  loadData() {
    this.isSpinning = true;
    const query: string = "SELECT * from chk_users";
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.usersData = res.data;
        const currDate: Date = new Date();
        const prevDate: Date = new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          1
        );
        // prevDate.setMonth(currDate.getMonth() - 1);
        this.rangeDate = new Array(prevDate, currDate);

        this.isSpinning = false;
      },
      (error: HttpErrorResponse) => {
        this.isSpinning = false;
        this.notification.error(
          "Si è vericato un errore non previsto",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }
  selectUsers() {
    this.selectedUsers = this.usersData.filter(
      (u) => u.company === this.selectedCompany
    );
    this.selectedUser = null;
  }

  loadTimes() {
    this.isLoading = true;
    // tslint:disable-next-line:max-line-length
    const query: string =
      "SELECT chk_times.id, chk_times.date, chk_times.userId, chk_times.orderId, chk_times.h, chk_orders.id, chk_orders.code, chk_orders.title, chk_orders.forecast, chk_orders.company, chk_orders.status, chk_orders.total, chk_orders.prize, chk_orders.costH, chk_orders.costM, chk_orders.costMReal, chk_orders.date as data FROM chk_times left JOIN chk_orders ON chk_orders.id = chk_times.orderId" +
      " WHERE `userId`=" +
      this.selectedUser.id +
      ' AND chk_times.date >= "' +
      this.datepipe.transform(this.rangeDate[0], "yyyy-MM-dd") +
      '"' +
      ' AND chk_times.date <= "' +
      this.datepipe.transform(this.rangeDate[1], "yyyy-MM-dd") +
      '"' +
      " ORDER BY chk_times.date";
    console.log(query);
    return this.g.mysql(query).subscribe(
      (res: Result) => {
        console.log(res);

        this.isLoading = false;
        this.timesData = res.data;
        this.displayData = [...this.timesData];

        let n: number = 0;
        res.data.forEach((t) => {
          n += t.h;
        });
        this.currentTotale = n > 0 ? "Totale ore: " + n : "";
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto",
          error.statusText,
          { nzDuration: this.g.normalTime }
        );
      }
    );
  }
  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;
    if (this.sortName) {
      this.displayData = [
        ...this.timesData.sort((a, b) =>
          this.sortValue === "ascend"
            ? a[this.sortName] > b[this.sortName]
              ? 1
              : -1
            : b[this.sortName] > a[this.sortName]
            ? 1
            : -1
        ),
      ];
    } else {
      this.displayData = [...this.timesData];
    }
  }
  public getUser(userId: string): string {
    const res = this.usersData.find((u) => u.id === userId);
    if (res) {
      return res.name;
    } else {
      return "(non trovato)";
    }
  }
}
